import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from './adviserAddContainerActions'
import AdviserAdd from './AdviserAdd'
import SubmitSpinner from '../../../../common/Spinners/SubmitSpinner'
import SuccessCheckmessage from '../../../../common/SuccessCheckMessage'

class AdviserAddContainer extends React.Component {
  static propTypes = {
    submitAdviser: PropTypes.bool.isRequired,
    submittingAdviser: PropTypes.bool.isRequired,
    submittedAdviser: PropTypes.bool.isRequired,
    adviser: PropTypes.object.isRequired,
    validationstate: PropTypes.object.isRequired,

    setIfaCode: PropTypes.func.isRequired,
    setFirstName: PropTypes.func.isRequired,
    setMiddleName: PropTypes.func.isRequired,
    setLastName: PropTypes.func.isRequired,
    submitNewAdviser: PropTypes.func.isRequired
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.submitAdviser && this.props.submitAdviser) {
      this.props.submitNewAdviser(this.props.adviser)
    }
  }

  render() {
    return (
      <AdviserAdd
        submittingAdviser={this.props.submittingAdviser}
        adviser={this.props.adviser}
        validationstate={this.props.validationstate}
        setIfaCode={this.props.setIfaCode}
        setFirstName={this.props.setFirstName}
        setMiddleName={this.props.setMiddleName}
        setLastName={this.props.setLastName}
        submitNewAdviser={this.props.submitNewAdviser}
      >
        {this.props.submittingAdviser && <SubmitSpinner />}
        {this.props.submittedAdviser && (
          <SuccessCheckmessage message="Adviser Added" />
        )}
      </AdviserAdd>
    )
  }
}

const mapStateToProps = ({ adviserAdd }) => ({
  submitAdviser: adviserAdd.submitAdviser,
  submittingAdviser: adviserAdd.submittingAdviser,
  submittedAdviser: adviserAdd.submittedAdviser,
  adviser: adviserAdd.adviser,
  validationstate: adviserAdd.isInvalid
})

const mapDispatchToProps = (dispatch) => {
  const { setting, submit } = actions

  return bindActionCreators(
    {
      setIfaCode: setting.ifaCode,
      setFirstName: setting.firstName,
      setMiddleName: setting.middleName,
      setLastName: setting.lastName,
      submitNewAdviser: submit.adviser
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdviserAddContainer)